import BaseModel from "./_BaseModel";
import GroupCust from "./GroupCust";

export default class Customer extends BaseModel {
    public readonly ucode?: string;
	public kode?: string;
	public nama?: string;
	public npwp?: string;
    public ucode_group_cust?: string;
    public kode_group_cust?: string;
    public nama_group_cust?: string;
    public alamat?: string;
	public alamat_kirim?: string;
    public telp?: string;    
    public jatuh_tempo?: number;
	public keterangan?: string;
    public aktif?: boolean = true;
    public group_cust?: GroupCust;
    public is_new?: boolean = true;

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
}